import React from 'react';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import { Button, Typography } from 'antd';
import { useAuth } from '../../contexts/AuthContext';
import { signInCopyEn } from '../../content/signInCopy.en';
import { setPersona } from '../../utils/persona';
import styles from './SignIn.module.css';

const { Title, Paragraph, Text } = Typography;

const SignIn: React.FC = () => {
  const { login } = useAuth();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const redirectPath = searchParams.get('redirect');
  const isPro = location.pathname === '/signin/pro';
  const copy = isPro ? signInCopyEn.pro : signInCopyEn.user;

  const handleSignIn = (): void => {
    setPersona(isPro ? 'pro' : 'user');
    login(redirectPath || undefined);
  };

  const subtitle = redirectPath ? copy.sessionExpiredSubtitle : copy.subtitle;
  const showBenefits = !redirectPath;

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <div className={styles.panel}>
          <Text className={styles.eyebrow}>{copy.eyebrow}</Text>
          <Title level={1} className={styles.title}>
            {copy.title}
          </Title>
          <Paragraph className={styles.subtitle}>{subtitle}</Paragraph>
          <Button
            type="primary"
            size="large"
            onClick={handleSignIn}
            className={styles.ctaButton}
          >
            {copy.cta}
          </Button>
          {showBenefits && (
            <ul className={styles.benefits}>
              {copy.benefits.map((benefit) => (
                <li key={benefit}>{benefit}</li>
              ))}
            </ul>
          )}
          <div className={styles.alternate}>
            {isPro ? (
              <Link to={redirectPath ? `/signin?redirect=${encodeURIComponent(redirectPath)}` : '/signin'}>
                {copy.alternateLink}
              </Link>
            ) : (
              <Link to={redirectPath ? `/signin/pro?redirect=${encodeURIComponent(redirectPath)}` : '/signin/pro'}>
                {copy.alternateLink}
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
